<template>
  <div id="landing">
    <Login v-if="components.login" v-on:dismiss="components.login = false" v-on:complete="next" />
    <div class="top">
      <img src="https://cdn.anyteach.cn/homeclass-bgd.jpg?imageView2/0/w/1000" />
      <div class="text">
        <h1>欢迎使用</h1>
        <h2>同城拼课</h2>
      </div>
    </div>
    <div class="bottom">
      <p>
        和同城市、同小区小伙伴在家拼课，一起享受 AnyTeach
        中外精英教师团上门授课。选择课时包、定制上课时间地点，发起 1 至 8
        人拼课。邀请首单好更可以立减学费 10%，最高可免 2 万元！
      </p>
      <p>点击「下一步」开始拼课。</p>
      <router-link class="link" tag="div" to="/homeclass/faq">了解更多</router-link>
    </div>
    <div class="action-button" @click="next">下一步</div>
  </div>
</template>
<script>
import Login from "@/components/popup/Login"
export default {
  name: "Landing",
  components: { Login },
  data() {
    return {
      isShowPopup: false,
      popupMsg: "",
      components: {
        login: false,
      },
    }
  },
  methods: {
    next() {
      if (this.$store.state.user.mobile) {
        return this.$emit("state", 1)
      } else {
        return (this.components.login = true)
      }
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/prog-form.scss";

#landing {
  .top {
    position: relative;
    padding: 25% 5% 10px 5%;
    .text {
      position: relative;
    }
    img {
      width: 60%;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  .bottom {
    padding: 20px 5%;
  }
  .action-button {
    bottom: 0;
  }
  h1,
  h2 {
    font-size: 25px;
    line-height: 1;
  }
  h1 {
    font-weight: 300;
    margin: 0 0 5px 0;
  }
  h2 {
    font-weight: bold;
    margin: 0 0 5px 0;
  }
  p {
    font-size: 0.9rem;
    line-height: 1.7;
    margin-bottom: 20px;
    @include avenir();
    ul {
      padding-left: 5%;
    }
    li {
      list-style: initial;
    }
  }
  .link {
    background: white;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 10px;
    text-align: center;
    font-weight: 500;
    font-size: 13px;
    color: $red;
    margin: 0 0 50px 0;
    &:active {
      opacity: 0.7;
    }
  }
}
</style>
